var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", {
    attrs: { title: "Term of Service Management" },
    scopedSlots: _vm._u([
      {
        key: "button",
        fn: function() {
          return [
            _c("Button", {
              attrs: { variant: "primary", label: _vm.labelSaveButton },
              on: { clicked: _vm.save }
            })
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("ckeditor", {
              attrs: {
                editor: _vm.editor,
                config: _vm.editorConfig,
                disabled: _vm.isLoading
              },
              on: { ready: _vm.onReady },
              model: {
                value: _vm.editorData,
                callback: function($$v) {
                  _vm.editorData = $$v
                },
                expression: "editorData"
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5948b882", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5948b882","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TncManagement.vue
// module id = null
// module chunks = 